import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, MapPin, UserPlus } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";
import { itDate } from "@/lib/download";

export const PostersSection = ({ ownerId }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(`/events/by/${ownerId}`).then((r) => setItems(r.data.filter((e) => e.posterUrl))).catch(() => {}); }, [ownerId]);
  if (!items.length) { return null; }
  const [first, ...rest] = items;
  return (
    <div data-testid="profile-posters">
      <div className="overline text-gold mb-3">Locandine ed eventi</div>
      <div className="grid sm:grid-cols-[1.2fr_1fr] gap-4">
        <a href={mediaUrl(first.posterUrl)} target="_blank" rel="noreferrer" className="block rounded-2xl overflow-hidden border border-slate-200" data-testid="profile-poster-latest">
          <img src={mediaUrl(first.posterUrl)} alt={first.title} className="w-full object-cover"/>
          <div className="p-3 bg-white"><div className="font-semibold">{first.title}</div><div className="text-xs text-slate-500 flex items-center gap-2"><CalendarDays className="w-3.5 h-3.5"/>{itDate(first.date)}<MapPin className="w-3.5 h-3.5"/>{first.place}</div></div>
        </a>
        {rest.length > 0 && <div className="grid grid-cols-2 gap-3 content-start">{rest.map((e) => <a key={e.id} href={mediaUrl(e.posterUrl)} target="_blank" rel="noreferrer" title={e.title}><img src={mediaUrl(e.posterUrl)} alt={e.title} loading="lazy" className="w-full aspect-[3/4] object-cover rounded-xl hover:opacity-90 transition-opacity"/></a>)}</div>}
      </div>
    </div>
  );
};

export const GuestSlogan = () => (
  <div className="mt-6 rounded-2xl bg-aic-navy text-white p-5 flex flex-col sm:flex-row sm:items-center gap-4" data-testid="guest-slogan">
    <p className="font-logo italic text-lg text-gold flex-1">Per scoprire tutto su questo artista, vedere le disponibilità e leggere le recensioni, iscriviti gratuitamente!</p>
    <Link to="/registrati" data-testid="guest-slogan-register" className="btn-pill-gold text-sm shrink-0"><UserPlus className="w-4 h-4"/>Iscriviti gratis</Link>
  </div>
);
